// extracted by mini-css-extract-plugin
export default {"mobileNav":"MobileNavigation_mobileNav__gFPMb","navItem":"MobileNavigation_navItem__WZs9s","icon":"MobileNavigation_icon__6AzCE","activeLabel":"MobileNavigation_activeLabel__+9Clb"};